import React, { useMemo, useContext } from 'react';

import TextSlider from 'components/TextSlider';
import { useTextSliderQuery } from 'hooks/useTextSliderQuery';
import useLiveData from 'hooks/useLiveData';

import { PersonalizationContext } from 'components/Personalization/PersonalizationContext';

const TextSliderProvider = ({ children, staticData, id }) => {
	const { matchAudience } = useContext(PersonalizationContext);
	const { data } = useTextSliderQuery();
	const shouldLimitLiveDataByStaticIds = !staticData;
	const effectiveStaticData = React.useMemo(() => staticData || data || {}, [staticData, data]);
	const textSliderEdges = effectiveStaticData?.allTextSlider?.edges || [];
	const textSliderNodes = textSliderEdges.map(({ node }) => node);

	const {
		statusText: textSliderStatusText,
		response: textSliderResponse,
		visibilityChange: textSliderVisibilityChange,
	} = useLiveData({
		namespace: 'SmartTags',
		model: 'TextSlider',
		method: 'all',
		graphqlKey: 'allSmartTagsTextSlider',
		apiParams: {
			archived: false,
			approved: true,
			deleted: false,
			_join: 'Audience',
			...(shouldLimitLiveDataByStaticIds && textSliderNodes.length > 0 ? {
				id: textSliderNodes.map((n) => n.id).join(','),
			} : {}),
			...(!!id ? { id } : {}),
		},
		staticData: effectiveStaticData,
	});

	const liveTextSlider = textSliderResponse?.data[0];
	let ts = textSliderNodes[0];
	if (!!liveTextSlider && textSliderStatusText === 'LOADED') {
		ts = liveTextSlider;
	}
	if (!!liveTextSlider && textSliderVisibilityChange) ts = liveTextSlider;

	const datum = useMemo(() => ts, [ts]);

	if (datum && datum?.hasOwnProperty('Audience') && datum?.Audience) {
		if (!matchAudience(datum?.Audience)) {
			return null;
		}
	}

	return (
		<TextSlider {...datum} matchAudience={matchAudience} />
	);
};

export default TextSliderProvider;